(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("layer-update", [], factory);
	else if(typeof exports === 'object')
		exports["layer-update"] = factory();
	else
		root["layer-update"] = factory();
})(self, function() {
return 